"use strict";
/**
 * Shared className helpers used by the Settings editor row/card components.
 *
 * Centralizing these prevents drift between SystemRow, FieldCard, and the
 * mapping/record editors when the visual "changed" treatment evolves.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardChangedClass = exports.buildSystemCellClass = exports.summaryValueChangedClass = exports.inputChangedClass = void 0;
exports.inputChangedClass = function (changed) {
    return changed ? "ws-ai-hub-settings-input-changed" : "";
};
exports.summaryValueChangedClass = function (changed) {
    return changed
        ? "ws-ai-hub-settings-table-value ws-ai-hub-settings-summary-value-changed"
        : "ws-ai-hub-settings-table-value";
};
exports.buildSystemCellClass = function (isEditing) {
    return function (extra) {
        return [
            "ws-ai-hub-settings-system-cell",
            isEditing ? "ws-ai-hub-settings-system-cell-editing" : "",
            extra || "",
        ]
            .filter(Boolean)
            .join(" ");
    };
};
exports.cardChangedClass = function (hasUnsavedChanges) {
    return hasUnsavedChanges
        ? "ws-ai-hub-settings-card ws-ai-hub-settings-card-changed"
        : "ws-ai-hub-settings-card";
};
